import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <h1>nothing</h1>
        </div>
    );
};

export default ErrorPage;